export default __webpack_public_path__ + "static/elliott-aa603c03b4fa4a4d1c21db71dab28ee1.jpg";